
import { forwardRef, useRef } from "react";
import BookYourCall from "../images/1.png"
import BookYourCallRed from "../images/8.png"
import bellSound from "../audio/bell.mp3";
const BellComponent = forwardRef((props, ref) => {
    const isLeft = props.isLeft;
    const isWhite = props.isWhite;
    const audioRef = useRef(null);
    const playSound = () => {
        audioRef.current.currentTime = 0; // restart sound if clicked again
        audioRef.current.play();
        window.open("https://app.acuityscheduling.com/schedule.php?owner=37874169", '_blank');
    };
    return (
        <div>
            <img
                src={isWhite ? BookYourCall : BookYourCallRed}
                alt="Logo"
                onClick={playSound}
                className={`w-[150px] md:w-[300px] object-contain mx-auto cursor-pointer`}
            />

            {/* Hidden audio element */}
            <audio ref={audioRef}>
                <source src={bellSound} />
            </audio>
        </div>
    );
});
export default BellComponent;